import React from 'react';

const PaymentStatus = ({ members, month, year, onUpdateStatus, getStatus }) => {
  // Nomes dos meses para exibição
  const monthNames = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];
  
  // Verificar se o pagamento já deveria ter sido feito
  const shouldBePaid = (paymentDay) => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();
    
    // Se estamos olhando para um mês/ano passado, o pagamento já deveria ter sido feito
    if (year < currentYear || (year === currentYear && month < currentMonth)) {
      return true;
    }
    
    // Se estamos olhando para o mês atual, verificar o dia
    if (year === currentYear && month === currentMonth) {
      return today.getDate() >= parseInt(paymentDay);
    }
    
    // Se estamos olhando para o futuro, o pagamento ainda não é devido
    return false;
  };
  
  // Alternar status de pagamento
  const togglePaymentStatus = (memberId) => {
    const currentStatus = getStatus(memberId, month, year);
    const newStatus = currentStatus === 'paid' ? 'pending' : 'paid';
    onUpdateStatus(memberId, month, year, newStatus);
  };
  
  return (
    <div className="payment-status">
      <h3>Pagamentos para {monthNames[month]} de {year}</h3>
      
      {members.length === 0 ? (
        <p className="no-data">Nenhum colaborador cadastrado.</p>
      ) : (
        <div className="payment-grid">
          {members.map(member => {
            const status = getStatus(member.id, month, year);
            const isLate = shouldBePaid(member.paymentDay) && status !== 'paid';
            
            return (
              <div 
                key={member.id} 
                className={`payment-card ${status === 'paid' ? 'paid' : isLate ? 'late' : 'pending'}`}
                onClick={() => togglePaymentStatus(member.id)}
              >
                <div className="payment-status-indicator">
                  {status === 'paid' ? '✅' : isLate ? '⚠️' : '⏳'}
                </div>
                <div className="payment-details">
                  <h4>{member.name}</h4>
                  <p>R$ {parseFloat(member.salary).toFixed(2)}</p>
                  <p className="payment-day">Dia {member.paymentDay}</p>
                </div>
                <div className="payment-status-label">
                  {status === 'paid' ? 'PAGO' : isLate ? 'ATRASADO' : 'PENDENTE'}
                </div>
              </div>
            );
          })}
        </div>
      )}
      
      <div className="payment-legend">
        <div className="legend-item">
          <span className="legend-indicator paid">✅</span>
          <span>Pago</span>
        </div>
        <div className="legend-item">
          <span className="legend-indicator pending">⏳</span>
          <span>Pendente</span>
        </div>
        <div className="legend-item">
          <span className="legend-indicator late">⚠️</span>
          <span>Atrasado</span>
        </div>
        <div className="legend-note">
          <small>Clique em um cartão para alternar o status do pagamento</small>
        </div>
      </div>
    </div>
  );
};

export default PaymentStatus;